import React, { ReactNode } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { useTranslate } from '@pegasus/translation';
import { ErrorBoundary } from '@browsing/components';

import Footer from '@client/components/footer';
import Header from '@client/components/header';
import LoadableGenericErrorMessage from '@client/components/shared/genericErrorMessage';
import { GlobalStyle } from '@client/styles/styled-components/global-styles';
import { isTouchScreen } from '../helpers';

import '../styles/core.scss';

type Props = {
    children: ReactNode;
};

const GuestLayout: React.FC<Props> = ({ children }) => {
    const location = useLocation();
    const translate = useTranslate('meta');

    const getPageClassName = () => {
        return location.pathname.split('/')[1];
    };

    return (
        <>
            <GlobalStyle />
            <div
                id="inner-wrapper"
                className={classNames('brand-color', `${getPageClassName()}-page`, {
                    'touch-device': isTouchScreen(),
                    'not-touch-device': !isTouchScreen(),
                })}
            >
                <Helmet
                    titleTemplate={`%s - ${translate('title')}`}
                    defaultTitle={translate('title')}
                    meta={[
                        {
                            name: 'description',
                            content: translate('description'),
                        },
                        {
                            name: 'keywords',
                            content: translate('keywords'),
                        },
                    ]}
                />
                <Header isGuest />
                <ErrorBoundary fallbackUI={LoadableGenericErrorMessage} componentName="GuestLayout">
                    {children}
                </ErrorBoundary>
                <Footer />
            </div>
        </>
    );
};

export default GuestLayout;
